import type { LiveVideo } from '@/signalr';

export function getLatestRecording(liveVideos: readonly LiveVideo[]): LiveVideo | null {
  let latest: LiveVideo | null = null;
  for (const liveVideo of liveVideos) {
    if (latest === null || Date.parse(liveVideo.startTimeUtc) > Date.parse(latest.startTimeUtc)) {
      latest = liveVideo;
    }
  }
  return latest;
}

const THREE_DAYS_MS = 3 * 24 * 60 * 60 * 1000;

export function showRecordings(latestRecording: LiveVideo | null, nowMs: number = Date.now()): boolean {
  return latestRecording !== null && nowMs < Date.parse(latestRecording.startTimeUtc) + THREE_DAYS_MS;
}
